import React from 'react'
import { BLOCKS, MARKS } from '@contentful/rich-text-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import {
	HeroSection,
	HeroItemsContainer,
	HeroButtons,
	HeroSeeAllLink,
	HeroSeeAll,
	HeroBookLink,
	HeroBook,
	Bold,
	Heading1,
	BannerText,
	DolphinLogo,
	ClientCareLogo,
	BookDemoLink,
	BookDemo,
} from './styles'

const heroBannerOptions = {
	renderMark: {
		[MARKS.BOLD]: text => <Bold>{text}</Bold>,
	},
	renderNode: {
		[BLOCKS.HEADING_1]: (node, children) => <Heading1>{children}</Heading1>,
		[BLOCKS.PARAGRAPH]: (node, children) => <BannerText>{children}</BannerText>,
	},
}

const Hero = ({
	mainActionText,
	mainActionUrl,
	secondActionText,
	secondActionUrl,
	thirdActionText,
	thirdActionUrl,
	description,
	heroLineUrl,
	sources,
	image,
	checkedLocale,
	locale
}) => {

	return (
		<HeroSection sources={sources}>
			<HeroItemsContainer sources={sources}>
				<ClientCareLogo src={image?.file?.url} alt={image?.description}></ClientCareLogo>
				<DolphinLogo src={heroLineUrl?.file?.url} alt={heroLineUrl?.description}></DolphinLogo>
				{documentToReactComponents(description?.json, heroBannerOptions)}
				<HeroButtons>
					{mainActionUrl != undefined || mainActionUrl != null ? (
						<HeroSeeAllLink to={`${mainActionUrl}`}>
							{mainActionText != undefined || mainActionText != null ? (
								<HeroSeeAll>{mainActionText}</HeroSeeAll>
							) : (
								''
							)}
						</HeroSeeAllLink>
					) : (
						''
					)}
					{
						locale === 'en-AU' || locale === 'en-NZ' ? (
							secondActionUrl != undefined || secondActionUrl != null ? (
								<HeroBookLink to={`/${secondActionUrl}`}>
									{secondActionText != undefined || secondActionText != null ? (
										<HeroBook>{secondActionText}</HeroBook>
									) : (
										''
									)}
								</HeroBookLink>
							) : (
								''
							)
						) : secondActionText.toLowerCase() != 'find a dealer' ? (
							secondActionUrl != undefined || secondActionUrl != null ? (
								<HeroBookLink to={`/${secondActionUrl}`}>
									{secondActionText != undefined || secondActionText != null ? (
										<HeroBook>{secondActionText}</HeroBook>
									) : (
										''
									)}
								</HeroBookLink>
							) : (
								''
							)
						) : ''
					}
					{thirdActionUrl != undefined || thirdActionUrl != null ? (
						<BookDemoLink to={'/' + thirdActionUrl}>
							{thirdActionText != undefined || thirdActionText != null ? (
								<BookDemo>{thirdActionText}</BookDemo>
							) : (
								''
							)}
						</BookDemoLink>
					) : (
						''
					)}
				</HeroButtons>
			</HeroItemsContainer>
		</HeroSection>
	)
}

export default Hero
